import { useRouteError } from 'react-router';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import * as React from 'react';

export default function ErrorSitePage() {
  const error: any = useRouteError();
  console.error(error);

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
      }}
    >
      <Container maxWidth="md">
        <Grid container spacing={2}>
          <Grid size={{ xs: 12 }}>
            <Typography variant="h1">400</Typography>
            <Typography variant="h6">
              Sorry, an unexpected error has occurred.
            </Typography>
            <Typography variant="h6">
              {error?.statusText || error?.message}
            </Typography>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}
